import React from "react";
import Cv from "./Cv";

function Step1() {
  return (
    <div style={{ marginTop: "30px" }}>
      <Cv />
    </div>
  );
}

export default Step1;
